import { Component, OnInit } from '@angular/core';
import { VendorsList, QuotationAttachment } from 'src/app/shared/models/app-models/SourcingOutcome.model';
import { Input } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { BackendApiService } from 'src/app/core/services/backend-api';
import { StatusData } from 'src/app/modules/rfq-summary/rfq-summary.component';
import {
  UserInformation,
  ExtendedKeycloakUser
} from 'src/app/shared/models/app-models';
import { SummaryDropdown } from 'src/app/modules/rfq-summary/rfq-summary.component';

@Component({
  selector: 'app-vendor-documents',
  templateUrl: './vendor-documents.component.html',
  styleUrls: ['./vendor-documents.component.scss']
})

export class VendorDocumentsComponent implements OnInit {
  @Input() vendorList: VendorsList[] = [];
  @Input() statusData!: StatusData;
  @Input() user!: UserInformation;
  @Input() userList!: ExtendedKeycloakUser[];
  rfqAttachments: SummaryDropdown[] = [];
  isDownloadAllDisabled: boolean = false;
  @Input() isReadOnlyRFQSummary: boolean = false;

  constructor(
    private backendService: BackendApiService) {
    this.getRFQAttachment();
  }

  ngOnInit() {
    this.sortVendorList();
    this.checkAttachments();
  }

  sortVendorList() {
    this.vendorList = this.vendorList.sort((a, b) => {
      const numA = Number(a.VendorNumber);
      const numB = Number(b.VendorNumber);
      return numA - numB;
    });
  }

  checkAttachments(): void {
    this.isDownloadAllDisabled = this.vendorList.every((vendor) =>
      vendor.QuotationAttachment.length === 0 ||
      vendor.QuotationAttachment.every((attachment) => attachment.IsDeleted || attachment.IsStrikethrough)
    );
  }

  async getRFQAttachment() {
    try {
      const response: SummaryDropdown[] = await lastValueFrom(
        this.backendService.getRFQAttachment()
      );
      this.rfqAttachments = response;
      this.preSelectPurpose();
    } catch (e) {
      console.log("Unable to retrieve the purpose for RFQ Attachements");
      this.rfqAttachments = [];
    }
  }

  async downloadAllData() {
    try {
      let data: any = await lastValueFrom(
        this.backendService.downloadAllVendorDoc(this.statusData.documentNo, this.statusData.rfqNum));
      const arrayBuffer: any = data.attachment.data;
      const int8Array = new Uint8Array(arrayBuffer);
      let blob = new Blob([int8Array], { type: 'application/zip' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(blob);
      a.download = this.statusData.rfqNum;
      a.click();
      window.URL.revokeObjectURL(a.href);
    } catch (e) {
      alert('error downloading');
    }
  }

  preSelectPurpose() {
    this.vendorList.forEach((vendor: VendorsList) => {
      if (vendor.QuotationAttachment.length > 0) {
        vendor.QuotationAttachment.forEach((quotation: QuotationAttachment) => {
          if (!quotation.AttachmentTypeId) {
            quotation.AttachmentTypeId = this.rfqAttachments[0]?.Id;
            vendor.Status = true;
          }
        });
      }
    });
  }
}
